export const THEME_STORAGE_KEY = "reelitpro_theme";

export const THEME_MODES = {
  LIGHT: "light",
  DARK: "dark",
};

export function normalizeThemeMode(value) {
  return value === THEME_MODES.DARK ? THEME_MODES.DARK : THEME_MODES.LIGHT;
}

export function getInitialThemeMode() {
  if (typeof window === "undefined" || !window.localStorage) {
    return THEME_MODES.LIGHT;
  }

  return normalizeThemeMode(window.localStorage.getItem(THEME_STORAGE_KEY));
}

export function setStoredThemeMode(mode) {
  if (typeof window === "undefined" || !window.localStorage) {
    return;
  }

  window.localStorage.setItem(THEME_STORAGE_KEY, normalizeThemeMode(mode));
}

export function applyThemeMode(mode) {
  if (typeof document === "undefined") {
    return;
  }

  document.documentElement.dataset.theme = normalizeThemeMode(mode);
}

export function isDarkTheme(mode) {
  return normalizeThemeMode(mode) === THEME_MODES.DARK;
}
